import { Product, Variant } from "@/types/types.ts";
import {
  isVariantReducedToClear,
  isVariantPromotional,
  isAllVariantsReduced,
  isAllVariantsSave,
  isAllVariantsReducedForColour,
  isSomeVariantsReducedForColour,
  isAllVariantsSaveForColour,
  isSomeVariantsSaveForColour,
} from "./promotionUtils";
import { getColourGroupForVariant } from "@/utils/product/getColourGroupForVariant.ts";

export const getSizeReductionLabelInfo = (
  product: Product,
  sizeVariant: Variant,
  showPromoOnIndicators: boolean,
  isUnavailable: boolean,
) => {
  if (isUnavailable) {
    return {
      showReduced: false,
      label: "",
    };
  }

  const variants: Variant[] = product.variants;

  const isAllVariantsReducedToClear = isAllVariantsReduced(product);
  const isAllVariantsOnSave = isAllVariantsSave(product);

  if (isAllVariantsReducedToClear || isAllVariantsOnSave) {
    return {
      showReduced: showPromoOnIndicators,
      label: showPromoOnIndicators
        ? isAllVariantsReducedToClear
          ? "Reduced"
          : "Offer"
        : "",
    };
  }

  const isReducedToClear = isVariantReducedToClear(sizeVariant);
  const isSave = isVariantPromotional(sizeVariant);
  const reducedOrOfferLabel = isReducedToClear
    ? "Reduced"
    : isSave
      ? "Offer"
      : "";

  if (!(variants[0] as Variant).differentiators?.colour) {
    return {
      showReduced: isReducedToClear || isSave,
      label: reducedOrOfferLabel,
    };
  }

  const variantGroup = getColourGroupForVariant(
    product.variantGroups,
    sizeVariant.id,
  );

  if (variantGroup && isAllVariantsReducedForColour(variantGroup)) {
    return {
      showReduced: showPromoOnIndicators,
      label: showPromoOnIndicators ? reducedOrOfferLabel : "",
    };
  }

  if (variantGroup && isAllVariantsSaveForColour(variantGroup)) {
    return {
      showReduced: showPromoOnIndicators,
      label: showPromoOnIndicators ? reducedOrOfferLabel : "",
    };
  }

  if (
    variantGroup &&
    (isSomeVariantsReducedForColour(variantGroup) ||
      isSomeVariantsSaveForColour(variantGroup))
  ) {
    return {
      showReduced: isReducedToClear || isSave,
      label: reducedOrOfferLabel,
    };
  }

  return { showReduced: false, label: "" };
};
